import { render, staticRenderFns } from "./GRoundedButton.vue?vue&type=template&id=b88c5b2c&scoped=true&"
import script from "./GRoundedButton.vue?vue&type=script&lang=ts&"
export * from "./GRoundedButton.vue?vue&type=script&lang=ts&"
import style0 from "./GRoundedButton.vue?vue&type=style&index=0&id=b88c5b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c5b2c",
  null
  
)

export default component.exports